<template>
  <div>
    <el-row type="flex" class="row-bg" justify="end"
      ><el-col :span="2.5"
        ><el-switch
          v-model="showSupplierInfo"
          active-text="显示供应商信息"
          inactive-text="隐藏供应商信息"
        ></el-switch
      ></el-col>
    </el-row>

    <!-- 多条件筛选区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-select
        v-model="searchCustomerId"
        filterable
        clearable
        placeholder="购买客户筛选"
      >
        <el-option
          v-for="item in customerList"
          :key="item.objectId"
          :label="item.name"
          :value="item.objectId"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="searchOrderNumber"
        placeholder="订单号筛选"
        clearable
        style="margin-left: 20px; width: 200px"
      />

      <el-input
        v-model="searchPartName"
        placeholder="配件名称筛选"
        clearable
        style="margin-left: 20px; width: 200px"
      />

      <el-input
        v-model="searchCarModelCompatibility"
        placeholder="适用车型筛选"
        clearable
        style="margin-left: 20px; width: 200px"
      />

      <el-select
        v-model="searchSupplierId"
        filterable
        clearable
        placeholder="供应商筛选"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in supplierList"
          :key="item.objectId"
          :label="item.name"
          :value="item.objectId"
        >
        </el-option>
      </el-select>

      <el-button type="primary" @click="handleSearch" style="margin-left: 20px">
        筛选
      </el-button>
    </div>

    <!-- 数字输入弹窗 -->
    <el-dialog
      title="输入数量"
      :visible.sync="dialogVisible"
      :before-close="handleDialogClose"
      width="300px"
    >
      <el-input-number
        v-model="returnDetails.quantity"
        :min="1"
        :max="1000"
      ></el-input-number>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addReturnDetail">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
      v-loading="loading"
    >
      <el-table-column
        prop="orderNumber"
        label="订单编号"
        width="260"
      ></el-table-column>

      <el-table-column prop="partName" label="配件名称"></el-table-column>

      <el-table-column
        prop="carModelCompatibility"
        label="适用车型"
        width="260"
      ></el-table-column>

      <el-table-column prop="unit" label="单位" width="80"></el-table-column>

      <el-table-column
        prop="quantity"
        label="数量"
        width="100"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="supplierId"
        label="供货商"
        width="240"
        v-if="showSupplierInfo"
        :formatter="formatSupplierText"
      ></el-table-column>

      <el-table-column
        prop="unitPrice"
        label="进价"
        width="120"
        v-if="showSupplierInfo"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="customerId"
        label="购买客户"
        width="240"
        :formatter="formatCustomerText"
      ></el-table-column>

      <el-table-column
        prop="sellPrice"
        label="售价"
        width="120"
      ></el-table-column>

      <el-table-column label="操作" width="200px">
        <template #default="{ row }">
          <el-button type="primary" size="mini" @click="openReturnDialog(row)">
            标记退货
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tableData: [], // 表格数据

      searchOrderNumber: "",
      searchPartName: "",
      searchCarModelCompatibility: "",
      searchSupplierId: "",
      searchCustomerId: "",

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 总数据量
      loading: false, // 加载状态

      customerList: [],
      supplierList: [],
      customerMap: new Map(),
      supplierMap: new Map(),

      showSupplierInfo: true,

      dialogVisible: false,
      returnDetails: {
        automotivePartId: "",
        quantity: 1,
      },
    };
  },

  created() {
    this.fetchData();
    this.fetchCustomerData();
    this.fetchSupplierData();
  },

  methods: {
    // 获取表格数据
    async fetchData() {
      try {
        this.loading = true;
        const params = {
          orderNumber: this.searchOrderNumber,
          partName: this.searchPartName,
          carModelCompatibility: this.searchCarModelCompatibility,
          supplierId: this.searchSupplierId,
          customerId: this.searchCustomerId,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        };
        const response = await axios.post(
          "/api/OrderDetail/getOrderDetailList",
          params
        );

        this.tableData = response.data.result;
        this.total = response.data.total;
      } finally {
        this.loading = false;
      }
    },

    // 客户数据加载
    async fetchCustomerData() {
      try {
        const response = await axios.get("/api/Customer/getAllCustomer");

        this.customerList = response.data.result;

        this.customerMap = new Map();
        for (var item of response.data.result) {
          this.customerMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 供应商数据加载
    async fetchSupplierData() {
      try {
        const response = await axios.get("/api/Supplier/getAllSupplier");

        this.supplierList = response.data.result;

        this.supplierMap = new Map();
        for (var item of response.data.result) {
          this.supplierMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 格式化客户字段
    formatCustomerText(row) {
      return this.customerMap.get(row.customerId) || "未知客户";
    },

    // 格式化供应商字段
    formatSupplierText(row) {
      return this.supplierMap.get(row.supplierId) || "未知供应商";
    },

    // 切换每页数量
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    // 切换页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    // 搜索
    handleSearch() {
      this.fetchData();
    },

    // 打开退货详情
    openReturnDialog(row) {
      this.returnDetails.automotivePartId = row.partId;
      this.returnDetails.quantity = row.quantity;

      this.dialogVisible = true;
    },

    // 对话框关闭时重置表单
    handleDialogClose() {
      this.returnDetails.automotivePartId = "";
      this.returnDetails.quantity = 1;
    },

    // 新增退货
    async addReturnDetail() {
      try {
        // 调用新增接口
        var response = await axios.post(
          "/api/AutomotivePart/addInventory",
          this.returnDetails
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("新增退货信息成功");

          await this.fetchData();

          this.dialogVisible = false;
        } else {
          this.$message.error(
            `新增退货信息失败: ${response.data.result.message}`
          );
        }
      } catch (error) {
        console.error("新增退货信息失败:", error);
        this.$message.error(
          error.response?.data?.message || "新增退货信息失败"
        );
      }
    },
  },
};
</script>

<style scoped>
.filter-section {
  margin-bottom: 20px;
}

.el-col {
  margin-bottom: 10px;
}

.error-alert {
  margin-bottom: 20px;
}

.part-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.part-item >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.action-bar {
  text-align: center;
  margin-top: 20px;
}
</style>